module.exports = __webpack_public_path__ + "static/media/template.8ddc8b0f.svg";